import { useEffect, useRef, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { FiBookOpen } from "react-icons/fi";

import CourseSubSectionAccordion from "./CourseSubSectionAccordion";

export default function CourseAccordionBar({ course, isActive, handleActive, isLast }) {
  const contentRef  = useRef(null);
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setOpen(isActive?.includes(course._id));
  }, [isActive, course._id]);

  useEffect(() => {
    setHeight(open ? contentRef.current?.scrollHeight ?? 0 : 0);
  }, [open]);

  return (
    <div className={`bg-richblack-800 ${!isLast ? "border-b border-richblack-700" : ""}`}>
      {/* Header row */}
      <button
        type="button"
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 hover:bg-richblack-700/50"
        onClick={() => handleActive(course._id)}
      >
        <div className="flex items-center gap-3 min-w-0">
          <FiChevronDown
            className={`flex-shrink-0 text-richblack-300 transition-transform duration-300 ${
              open ? "rotate-180" : "rotate-0"
            }`}
          />
          <span className="text-sm font-semibold text-richblack-5 leading-snug">
            {course.sectionName}
          </span>
        </div>
        <div className="flex flex-shrink-0 items-center gap-1.5 text-xs text-richblack-400">
          <FiBookOpen className="flex-shrink-0" />
          {course.subSection?.length ?? 0} lecture{course.subSection?.length !== 1 ? "s" : ""}
        </div>
      </button>

      {/* Collapsible content */}
      <div
        ref={contentRef}
        className="overflow-hidden transition-[height] duration-300 ease-in-out"
        style={{ height }}
      >
        <div className="flex flex-col divide-y divide-richblack-700 bg-richblack-900/60 px-5">
          {course.subSection?.map((sub, i) => (
            <CourseSubSectionAccordion key={i} subSec={sub} />
          ))}
        </div>
      </div>
    </div>
  );
}
